/* eslint-disable import/no-extraneous-dependencies */
/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import axios from "axios";
import installNoCache from "utils/noCache";
import installAuthToken from "utils/authToken";
import "./i18n";

// Soft UI Dashboard React Context Provider
import { SoftUIControllerProvider } from "context";

// every request fresh from the server, before anything asks for one - see
// utils/noCache
installNoCache(window, axios);
// every add, edit and delete says who sent it, for the audit log - see
// utils/authToken
installAuthToken(window, axios);

ReactDOM.render(
  <BrowserRouter>
    <SoftUIControllerProvider>
      <App />
      {/* <Route exact path="/patients/addpatient" component={AddUser} /> */}
    </SoftUIControllerProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
